<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc">Contents</h2>
<p class="TOC-chapter sgc-4"><a href="#/Text/WordfromAuthor">A Word from the Author</a></p>
<p class="TOC-chapter sgc-4"><a href="#/Text/Preface">Preface</a></p>
<p class="TOC-chapter sgc-4"><span class="bold sgc-3"><a href="#/Text/chap1">1. A Paradox About Hearing God</a></span></p>
<p class="TOC-sub sgc-5">Why do people say they hear God but so few can explain it?</p>
<p class="TOC-chapter sgc-4"><span class="bold sgc-3"><a href="#/Text/chap2">2. Guidelines for Hearing from God</a></span></p>
<p class="TOC-sub sgc-5">What are some common misunderstandings?</p>
<p class="TOC-scripture sgc-8">Hearing God in Scripture: <em class="italic sgc-6">1 Kings 19:2-18</em> <em class="italic char-style-override-4 sgc-7">48</em></p>
<p class="TOC-chapter sgc-4"><span class="bold sgc-3"><span href="#/Text/chap3" title="Link target outside of Sample">3. Never Alone</span></span></p>
<p class="TOC-sub sgc-5">How is God with us?</p>
<p class="TOC-chapter sgc-4"><span class="bold sgc-3"><span href="#/Text/chap4" title="Link target outside of Sample">4. Our Communicating Cosmos</span></span></p>
<p class="TOC-sub sgc-5">Does God really talk to people?</p>
<p class="TOC-scripture sgc-8">Hearing God in Scripture: <em class="italic sgc-6">2 Kings 6:11-17</em> </p>
<p class="TOC-chapter sgc-4"><span class="bold sgc-3"><span href="#/Text/chap5" title="Link target outside of Sample">5. The Still, Small Voice and Its Rivals</span></span></p>
<p class="TOC-sub sgc-5">How has God spoken to people before?</p>
<p class="TOC-scripture para-style-override-6 sgc-9">Hearing God in Scripture: <em class="italic sgc-6">Proverbs 20:27;</em></p>
<p class="TOC-scripture sgc-8"><em class="italic sgc-6">1 Corinthians 2:9-13, 15-16</em> </p>
<p class="TOC-chapter sgc-4"><span class="bold sgc-3"><span href="#/Text/chap6" title="Link target outside of Sample">6. The Word of God and the Rule of God</span></span></p>
<p class="TOC-sub sgc-5">What part does God’s Word have in everyday reality?</p>
<p class="TOC-scripture sgc-8">Hearing God in Scripture: <em class="italic sgc-6">Psalm 19:1-6; 119:89-91</em> </p>
<p class="TOC-chapter sgc-4"><span class="bold sgc-3"><span href="#/Text/chap7" title="Link target outside of Sample">7. Redemption Through the Word of God</span></span></p>
<p class="TOC-sub sgc-5">How does hearing God lead to character transformation?</p>
<p class="TOC-scripture sgc-8">Hearing God in Scripture: <em class="italic sgc-6">Romans 5:10-11; 6:4, 8-11</em> </p>
<p class="TOC-chapter sgc-4"><span class="bold sgc-3"><span href="#/Text/chap8" title="Link target outside of Sample">8. Recognizing the Voice of God</span></span></p>
<p class="TOC-sub sgc-5">How do we know we are hearing God and not our own voices?</p>
<p class="TOC-scripture sgc-8">Hearing God in Scripture: <em class="italic sgc-6">1 Chronicles 14:8-17 </em></p>
<p class="TOC-chapter sgc-4"><span class="bold sgc-3"><span href="#/Text/chap9" title="Link target outside of Sample">9. A Life More Than Guidance</span></span></p>
<p class="TOC-sub para-style-override-9 sgc-10">How do we learn to listen to God?</p>
<p class="TOC para-style-override-9 sgc-2"><span href="#/Text/epilogue" title="Link target outside of Sample">Epilogue: <em class="italic sgc-6">The Way of the Burning Heart</em></span></p>
<p class="TOC para-style-override-9 sgc-2"><span href="#/Text/Appendix" title="Link target outside of Sample">Appendix: <em class="italic sgc-6">Key Questions and Answers</em></span></p>
<p class="TOC para-style-override-9 sgc-2"><span href="#/Text/eNotes" title="Link target outside of Sample">Notes</span></p>
<p class="TOC para-style-override-9 sgc-2"><span href="#/Text/ScripIndx" title="Link target outside of Sample">Scripture Index</span></p>
<p class="TOC para-style-override-9 sgc-2"><span href="#/Text/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?42187edd